"use client";

// Haiku API Integration for THJ Swap Widget
// Replaces Relay SDK with Haiku Intent API

// Re-export shared utilities
export {
  BERACHAIN_CHAIN_ID,
  fromHaikuIID,
  HENLO_TOKEN_ADDRESS,
  isNativeTokenOnChain,
  toHaikuIID,
} from "@/utils/haiku-utils";

// Haiku API Types
export type HaikuToken = {
  chainId: number;
  address: string;
  symbol: string;
  name: string;
  decimals: number;
  priceUSD: string;
  logoURI?: string;
  iid: string; // Haiku's unique identifier (chain:address)
  protocol?: string;
  marketCap: number;
};

export type HaikuChain = {
  id: number;
  name: string;
  displayName?: string;
  icon?: string;
};

export type HaikuBalance = {
  iid: string;
  balance: string;
  priceUSD: string;
  valueUSD: number;
};

export type HaikuQuote = {
  quoteId: string;
  funds: Array<{
    token: HaikuToken;
    amount: string;
  }>;
  balances: Array<{
    token: HaikuToken;
    amount: string;
  }>;
  fees: any[];
  approvals: any[];
  permit2Datas?: any;
  isComplexBridge: boolean;
  destinationBridge?: any;
  gas: {
    amount: string;
    usd: string;
  };
};

// Supported chains from Haiku documentation
export const HAIKU_SUPPORTED_CHAINS: HaikuChain[] = [
  { id: 1, name: "Ethereum", displayName: "Ethereum" },
  { id: 42161, name: "Arbitrum", displayName: "Arbitrum" },
  { id: 8453, name: "Base", displayName: "Base" },
  { id: 80094, name: "Berachain", displayName: "Berachain" },
  { id: 56, name: "BNB Smart Chain", displayName: "BSC" },
  { id: 146, name: "Sonic", displayName: "Sonic" },
  { id: 999, name: "HyperEVM", displayName: "HyperEVM" },
  { id: 137, name: "Polygon", displayName: "Polygon" },
  { id: 10, name: "Optimism", displayName: "Optimism" },
  { id: 130, name: "Unichain", displayName: "Unichain" },
  { id: 1329, name: "Sei", displayName: "Sei" },
  { id: 43114, name: "Avalanche", displayName: "Avalanche" },
  { id: 100, name: "Gnosis", displayName: "Gnosis" },
  { id: 534352, name: "Scroll", displayName: "Scroll" },
  { id: 747474, name: "Katana", displayName: "Katana" },
  { id: 33139, name: "Apechain", displayName: "Apechain" },
  { id: 480, name: "Worldchain", displayName: "Worldchain" },
];

// Get popular source chains for swapping to HENLO
export function getPopularSourceChains(): number[] {
  return [1, 42161, 8453, 10, 137, 56, 43114]; // Ethereum, Arbitrum, Base, Optimism, Polygon, BSC, Avalanche
}

// Popular tokens by chain for quick selection
export const POPULAR_TOKENS_BY_CHAIN: Record<number, string[]> = {
  1: ["ETH", "USDC", "USDT", "DAI", "WETH"],
  42161: ["ETH", "USDC", "USDT", "DAI", "ARB"],
  8453: ["ETH", "USDC", "USDT", "DAI"],
  10: ["ETH", "USDC", "USDT", "OP"],
  137: ["MATIC", "USDC", "USDT", "DAI"],
  56: ["BNB", "USDC", "USDT", "BUSD"],
  43114: ["AVAX", "USDC", "USDT"],
  80094: ["BERA", "HENLO", "HONEY", "USDC"],
};
